module.exports = __webpack_public_path__ + "img/victoria.ca2c74f4.png";